import { connect } from 'react-redux'
import ManagePlans from './ManagePlans'
import { returnUserIfUserExists } from '../../layouts/LoggedIn/actions'
import * as actions from './actions'

const mapStateToProps = (state, ownProps) => ({
  accountType: state.loginLayout.profile.accountType,
  stripeAccount: state.loginLayout.profile.stripeAccount,
  isUpdatingPlan: state.managePlans.isUpdatingPlan,
  planerror: state.managePlans.planerror,
  email: state.loginLayout.profile.email,

  ...ownProps
})

const mapDispatchToProps = dispatch => ({
  changePlan: (token, plan) => dispatch(actions.changePlan(token, plan)),
  returnUserIfUserExists: token => dispatch(returnUserIfUserExists(token))
})

const ManagePlansContainer = connect(mapStateToProps, mapDispatchToProps)(
  ManagePlans
)

export default ManagePlansContainer



// WEBPACK FOOTER //
// ./src/routes/ManagePlans/ManagePlansContainer.js